import React from 'react';
import PropTypes from 'prop-types';
import styles from './apiList.less';

function BaseInfo({ baseinfo = {}, name = '' }) {
    return (
        <div id='baseinfo' className={`${styles.baseinfoPanel} controledanchor`}>
            <h1>{name}</h1>
            <h2>接口基本信息</h2>
            <div className={styles.baseinfo}>
                <div title={baseinfo.discription}>用途说明：{baseinfo.discription}</div>
                <div title={baseinfo.httpmethod}>请求方式：{baseinfo.httpmethod}</div>
                <div title={baseinfo.urlformat}>请求URL：{baseinfo.urlformat}</div>
                <div title={baseinfo.creator}>创建者：{baseinfo.creator}</div>
            </div>
        </div>
    )
}
BaseInfo.propTypes = {
    baseinfo: PropTypes.object,
    name: PropTypes.string
}
export default BaseInfo;